import { FC, useState, createContext } from 'react';
import * as React from 'react';
import { UserModel } from '../models/user';

type AuthContext = {
  user: UserModel;
  token: any;
  isAuth: boolean;
  login: any;
  logout: any;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthContext = createContext<AuthContext>({} as AuthContext);

export const AuthProvider: FC = ({ children }) => {
  const initialToken = window.localStorage.getItem('token');
  const tempUser = window.localStorage.getItem('user');
  let initialUser = null;

  try {
    initialUser = tempUser ? JSON.parse(tempUser) : null;
  } catch (error) {
    console.error('Error parsing user data from localStorage:', error);
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('token');
  }
  const [user, setUser] = useState(initialUser);
  const [token, setToken] = useState(initialToken);

  const isAuth = !!token;

  const login = (user: any, token: any) => {
    setUser(user);
    setToken(token);
    window.localStorage.setItem('token', JSON.stringify(token));
    window.localStorage.setItem('user', JSON.stringify(user));
  };
  const logout = () => {
    setUser(null);
    setToken(null);
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('token');
  };

  return (
    <AuthContext.Provider value={{ user, token, isAuth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
